import Banner from 'components/Banner'
import LoadingContainer from 'components/LoadingContainer'
import { usePrepareCart } from 'hooks/usePrepareCart'
import useQueryString from 'hooks/useQueryString'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { toast } from 'react-toastify'
import api from 'services/api'
import useMediaQuery from '../../hooks/useMediaQuery'
import { BRANDS_WITH_REQUIRED_FREIGHT, MOBILE_WIDTH } from '../../utils/constants'
import { StyledCheckbox } from '../AppointmentScheduling/FormSteps/CheckoutStep/PaymentStep/styles'
import Step from '../NewCart/Steps'
import { Address } from './Address'
import { Customer } from './Customer'
import { Documents } from './NewDocuments/index'

import {
  BackCart,
  ButtonContainer,
  ButtonContinue,
  Container,
  ContainerResumePay,
  DocumentNotificationBox,
  TextDocument
} from './styles'

interface CustomerData {
  email: string
  cpf: string
  phone: string
  name: string
  birthday: string
  gender: 'male' | 'female' | 'other'
  phone_residencial?: string | undefined
}

interface AddressData {
  shippingAddress: any
  billingAddress: any
}

function NewCartDocuments() {
  const [isAllAddress, setIsAllAddress] = useState(false)
  const [isAllCustomerData, setIsAllCustomerData] = useState(false)
  const [error, setError] = useState(false)
  const isMobile = useMediaQuery(MOBILE_WIDTH)
  const [address, setAddress] = useState<AddressData>({
    shippingAddress: {},
    billingAddress: {}
  })
  const [customer, setCustomer] = useState<CustomerData>({} as CustomerData)
  const { lastOrderCreated, loading: loadignOrdens, getLastOrder } = usePrepareCart()
  const [documentList, setDocumentList] = useState({} as any)
  const [confirmDialogDocument, setConfirmDialogDocument] = useState(false)
  const originCheck = ['acolhimento-cannect', 'B2C', 'COD B', 'Recipe', 'COD C', 'app-cannect', 'agente-autonomo']
  const isOriginMatched = originCheck.some((origin) => origin === lastOrderCreated.originCheckout)
  const [showAnvisa, setShowAnvisa] = useState(false)
  const [showLaudoMedico, setShowLaudoMedico] = useState(false)
  const { items } = lastOrderCreated
  const deliveryByAssociation = lastOrderCreated?.deliveryByAssociation || false
  const atualURL = window.location.href
  const partUrl = atualURL.split('/')
  const cartWithautAuth = partUrl.pop()

  const hasProtocolProducts = items.some((item: any) => item?.product?.class_id === 4)
  const hasAssociationProducts = deliveryByAssociation

  const isAllSupplements = items.every(
    (item: any) =>
      item?.product?.class_id === 6 && !BRANDS_WITH_REQUIRED_FREIGHT.includes(item?.product?.brand_id || item?.brand_id)
  )

  const hasNormalImportedProducts = items.some(
    (item: any) => item?.product?.class_id !== 6 && item?.product?.class_id !== 4 && !deliveryByAssociation
  )

  const [loadingContainer, setLoading] = useState(false)
  const history = useHistory()
  const { filters } = useQueryString()
  const cart_id = filters?.cart_id

  const isValidateSubmit =
    !isAllAddress ||
    !isAllCustomerData ||
    (!isAllSupplements && (isOriginMatched ? documentList?.RECEITA?.length === 0 : !confirmDialogDocument))

  const validUrl = cart_id ? lastOrderCreated.uuid : lastOrderCreated.id

  useEffect(() => {
    getLastOrder()
  }, [])

  useEffect(() => {
    setCustomer(lastOrderCreated?.person)
  }, [lastOrderCreated])

  useEffect(() => {
    if (hasNormalImportedProducts) {
      setShowAnvisa(true)
    } else {
      setShowAnvisa(false)
    }
  }, [hasNormalImportedProducts])

  useEffect(() => {
    if (hasProtocolProducts || hasAssociationProducts) {
      setShowLaudoMedico(true)
    } else {
      setShowLaudoMedico(false)
    }
  }, [hasProtocolProducts, hasAssociationProducts])

  const handleAddress = (type: 'shippingAddress' | 'billingAddress', data: any) => {
    setAddress({ ...address, [type]: data })
  }

  const sendAdressesData = async () => {
    const BASE_PAYMENT_URL = cart_id ? 'order_cart_public' : 'order_cart'
    const { documents, recipes } = lastOrderCreated
    const { shippingAddress, billingAddress } = address

    try {
      if (!isAllAddress) throw new Error('Por favor, preencha todos os campos obrigatórios')

      setLoading(true)
      const payload = {
        documents:
          !isAllSupplements &&
          (documents?.flat()?.length > 0 || documents.length > 0) &&
          (documents?.documents_order || documents),
        recipes: [recipes[recipes.length - 1]],
        shippingAddress,
        billingAddress,
        items,
        customer,
        person_id: cart_id && lastOrderCreated?.person?.id
      }
      const { data } = await api.put(`/${BASE_PAYMENT_URL}/${lastOrderCreated.id}`, payload)

      if (data?.success) {
        await api
          .post(`payments/order/${data?.order?.id}`)
          .then((response) => {
            if (response?.data?.success) {
              if (cartWithautAuth === 'documentos') {
                history.push(`/finalizar-compra/${data?.order?.id}?cart_id=${data?.order?.uuid}`)
              } else {
                history.push(`/finalizar-compra-wa/${data?.order?.id}?cart_id=${cart_id}`)
              }
            }
          })
          .catch((error) => {
            const errorMsg = error?.response?.data?.errors
              ? error?.response?.data?.errors
              : 'Erro ao finalizar a compra'
            setError(true)
            toast.error(errorMsg || 'Erro ao finalizar a compra')
            return { error: true }
          })
      }
    } catch (error) {
      setError(true)
      return { error: true }
    } finally {
      setLoading(false)
    }
  }

  if (loadignOrdens || loadingContainer) return <LoadingContainer loading />

  const backToCart = () => {
    const url = cart_id ? `/carrinho-wa?cart_id=${cart_id}` : `/carrinho`
    history.push(`${url}`)
  }

  const isAllDocumentsUploaded =
    documentList?.RECEITA?.length > 0 &&
    documentList?.IDENTIDADE?.length > 0 &&
    documentList?.RESIDENCIAL?.length > 0 &&
    documentList?.ANVISA?.length > 0

  return (
    <Container isMobile={isMobile}>
      <Step step={2} />
      {!isAllSupplements &&
        !isAllDocumentsUploaded &&
        (isOriginMatched ? (
          <Documents
            orderIdObject={validUrl}
            returnDocs={setDocumentList}
            noImportCost={lastOrderCreated.noImportCost}
            deliveryByAssociation={lastOrderCreated.deliveryByAssociation}
            showAnvisa={showAnvisa}
            showLaudoMedico={showLaudoMedico}
          />
        ) : (
          <DocumentNotificationBox>
            <TextDocument>
              Eu declaro estar ciente de que, após efetuar o pagamento e a fim de permitir a continuidade do processo de
              importação dos produtos, assumo a responsabilidade por fornecer os seguintes documentos necessários,
              conforme exigido pela ANVISA (Agência Nacional de Vigilância Sanitária).
              <br />
              <br />
              Os documentos mencionados podem ser enviados na próxima tela:
              <br />
              <br />
              <ul>
                <li>Pedido/Receita médica válida (válida por 6 meses)</li>
                <li>Documento de identidade (RG ou CNH)</li>
                <li>Comprovante de residência</li>
                {deliveryByAssociation && <li>Comprovante de associação</li>}
                {deliveryByAssociation && <li>Termo de ajuizamento</li>}
                {!deliveryByAssociation && <li>Formulário ANVISA</li>}
              </ul>
              <br />
              <StyledCheckbox onChange={(e) => setConfirmDialogDocument(e.target.checked)}>
                Li e compreendi a necessidade de envio dos documentos.
              </StyledCheckbox>
            </TextDocument>
          </DocumentNotificationBox>
        ))}

      <ContainerResumePay isMobile={isMobile}>
        <Container isMobile={isMobile}>
          <Address
            setIsAllAddress={setIsAllAddress}
            handleAddress={handleAddress}
            hasAssociationProducts={hasAssociationProducts}
          />
        </Container>
        <Container isMobile={isMobile}>
          <Customer customer={customer} setCostumer={setCustomer} setIsAllCustomerData={setIsAllCustomerData} />
        </Container>
      </ContainerResumePay>
      {isValidateSubmit && (
        <Banner title="Para Finalizar a compra por favor preencha os seguintes campos" variant="negative">
          <div>
            {!isAllAddress && <p>Dados de entrega</p>}
            {!isAllCustomerData && <p>Dados pessoais</p>}
            {!confirmDialogDocument && !isOriginMatched && !isAllSupplements && (
              <p>Por favor, confirme a leitura das informações sobre a documentação necessária</p>
            )}
            {documentList?.RECEITA?.length === 0 && isOriginMatched && (
              <p>É obrigatório anexar uma receita médica para continuar</p>
            )}
          </div>
        </Banner>
      )}
      <ButtonContainer isMobile={isMobile}>
        <BackCart onClick={backToCart}>voltar para o carrinho</BackCart>
        <ButtonContinue onClick={sendAdressesData} disabled={isValidateSubmit}>
          Continuar
        </ButtonContinue>
      </ButtonContainer>
    </Container>
  )
}

export default NewCartDocuments
